import { Box, Button, Card, CardActions, CardContent, Chip, CircularProgress, Divider, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper, Stack, Typography } from "@mui/material"
import { formatMoney } from "../../../../services/utils"
import { AttachFile, Attachment, AttachMoney, Close, ContentCopy, DeliveryDining, Discount, EditDocument, MoneyOff, Payments, Receipt, Task } from "@mui/icons-material"
import CopyToClipboard from "react-copy-to-clipboard"
import { Movimentacao } from "../../mov.model";
import { MeioPagActions } from "../../../meioPag/meiopg.model";
import { handleShowSelecionarCanalDist } from "../../../canalDist/view/canalDist.select";
import { contasController } from "../../../contas/contas.controll";
import { useTransition } from "react";
import { CadastroContasModal, handleShowCadContasModal } from "../../../contas/view/contas.list";
import { CardMeioPagMov } from "./cardMp";

interface CardTotalizacaoProps {
    mov: Movimentacao;
    mutatorLocal: (value: any, field: string) => void;
    meioPagActions: MeioPagActions;
    funcionarioActions: any;
    setShowObsModal: (value: boolean) => void;
    setShowCopy: (value: boolean) => void;
    setShowDescontoModal: (value: boolean) => void;
    getTextMovToShared: () => string;
}

export const CardTotalizacao = (props: CardTotalizacaoProps) => {
    const { mov, mutatorLocal, meioPagActions, setShowObsModal, setShowCopy, setShowDescontoModal, getTextMovToShared } = props;
    const [transition, startStransition] = useTransition()
    const finalizar = async () => {
        const getDataVencimento = (): string => {
            const data = new Date()
            data.setDate(data.getDate() + 30)
            return data.toISOString()
        }
        let findGerarConta = mov.fechamento.pagamentos.find(v => v.gerar_titulo)
        if (findGerarConta !== undefined) {
            //setShowMsg("Genrando conta a pagar...","info")
            startStransition(async () => {
                let resp = await contasController.novaConta({
                    tipo: "receber",
                    pessoa: {
                        _id: mov.pessoa._id,
                        nome: mov.pessoa.nome
                    },
                    movimentacao: {
                        _id: mov._id,
                        codigo: mov.codigo,
                    },
                    descricao: `Nota gerada pela movimentação de ${mov.tipo_mov.descricao} N° ${mov.codigo}`,
                    valor: findGerarConta.valor,
                    data_venc: getDataVencimento()
                })
                if (resp.status === "ok") {
                    findGerarConta._id_conta = resp.row._id;
                    mutatorLocal(mov.fechamento.pagamentos, "meioPagUp")
                    //setShowMsg("Conta a receber gerada com sucesso!","info")
                }

            })
        }
        mutatorLocal("FINALIZADO", "situacao")
    }

    return (
        <Card sx={{ display: "flex", flex: 2, flexDirection: "column", pb: 1 }}>

            <Stack sx={{ display: "flex", flex: 5, flexDirection: "row", justifyContent: "space-between", alignContent: "baseline" }}>
                <Stack>
                    <Typography variant="caption" >Subtotal</Typography>
                    <Typography variant="h6" color="primary" >{formatMoney(mov.fechamento.subtotal)}</Typography>
                </Stack>
                <Stack>
                    <Typography variant="caption" >Descontos</Typography>
                    <Typography variant="h6" color="warning" >{formatMoney(mov.fechamento.descontos)}</Typography>

                </Stack>
                <Stack>
                    <Typography variant="caption" >Total</Typography>
                    <Typography variant="h5" color="success" >{formatMoney(mov.fechamento.total)}</Typography>
                </Stack>
            </Stack>


            <CadastroContasModal />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "end" }} >
                <Stack flexDirection={"row"} flex={1} gap={1}>
                    {mov.fechamento.pagamentos.length > 0 && (
                        <Box sx={{ display: "flex", flex: 3, flexDirection: "column" }}>
                            <Stack flexDirection={"row"} justifyContent={"start"} gap={1}>
                                {mov.fechamento.pagamentos.map((mp, idx) => {
                                    return (
                                        <CardMeioPagMov 
                                            key={idx} 
                                            mp={mp}
                                            mutatorLocal={mutatorLocal}
                                        />
                                           
                                    )

                                })}
                            </Stack>
                            {mov.fechamento.pagamentos.length > 0 && (mov.fechamento.pagamentos.map(mp => mp.valor).reduce((a, b) => a + b, 0) !== mov.fechamento.total) && (
                                <Typography variant="caption" color="error">O total de pagamento esta divergente!</Typography>
                            )}

                        </Box>
                    )}

                </Stack>
                <Stack display={"flex"} direction={"row"} spacing={1} justifyContent={"end"} >

                    <IconButton title="Informar observação" onClick={() => setShowObsModal(true)}>
                        <EditDocument />
                    </IconButton>


                    <IconButton
                        title="Adicionar meio de pagamento"
                        disabled={mov.fechamento.total === 0}
                        onClick={() => meioPagActions.setShowSelectModal(true)}
                    >
                        <Payments />
                    </IconButton>

                    <CopyToClipboard
                        text={getTextMovToShared()}
                        onCopy={() => setShowCopy(true)}

                    >
                        <IconButton
                            title="Copiar dados da movimentação"
                            disabled={!mov._id || mov.fechamento.total === 0}
                        >
                            <ContentCopy />
                        </IconButton>
                    </CopyToClipboard>

                    <IconButton
                        title="Entregador vai fazer a entrega"
                        onClick={() => handleShowSelecionarCanalDist(true)}
                        disabled={mov.fechamento.total === 0}
                    >
                        <DeliveryDining />
                    </IconButton>

                    <IconButton
                        title="Informar desconto"
                        onClick={() => setShowDescontoModal(true)}
                        disabled={mov.situacao === "FINALIZADO"}
                    >
                        <Discount />
                    </IconButton>

                    <IconButton
                        title="Finalizar a movimentação"
                        onClick={() => finalizar()}
                        disabled={mov.situacao !== "ENTREGA"}
                    >
                        {transition ? (
                            <CircularProgress />
                        ) : (
                            <Task />
                        )}

                    </IconButton>
                </Stack>
            </CardActions>
        </Card>

    )
}

